import { BlankSlate } from "@msuite/ui/blank-slate";
import type { AssignmentReferenceBookingsSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";
import { AssignmentReferenceSingleBookingForm } from "./assignment-reference-single-booking-form";

/** Props Interface */
interface AssignmentReferenceBookingsFormProps {
	date: string;
}

export function AssignmentReferenceBookingsForm({ date }: AssignmentReferenceBookingsFormProps) {
	const methods = useFormContext<AssignmentReferenceBookingsSchema>();
	const bookings = useWatch({ control: methods.control, name: "bookings" });

	/** Render */
	return (
		<div className="gap-4 py-4 v-stack">
			{!bookings?.length && <BlankSlate className="mx-4" />}
			{bookings?.map((booking, index) => (
				<AssignmentReferenceSingleBookingForm
					key={booking.id}
					index={index}
					isLast={index === bookings.length - 1}
					date={date}
				/>
			))}
		</div>
	);
}
